import { render, staticRenderFns } from "./TrainingReport.vue?vue&type=template&id=9890491e&scoped=true"
import script from "./TrainingReport.vue?vue&type=script&lang=js"
export * from "./TrainingReport.vue?vue&type=script&lang=js"
import style0 from "./TrainingReport.vue?vue&type=style&index=0&id=9890491e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9890491e",
  null
  
)

export default component.exports